import { useQuery } from "@tanstack/react-query";

import { useObjectUrl } from "@/shared/hooks/useObjectUrl";
import { isSectionSpecPdf } from "@/shared/models/SectionSpecUpload";
import { downloadSectionSpecDrawing } from "@/shared/repositories/SectionSpecRepository";
import { usePdfAspectRatio } from "@/shared/hooks/usePdfAspectRatio";

export interface DrawingPreview {
	blob: Blob | null;
	hasFile: boolean;
	objectUrl: string | null;
	isError: boolean;
	isPdf: boolean;
	aspectRatio: number | null;
}

interface SectionDrawingPreviewParams {
	fileId: number | null;
	fileName: string | null;
}

export const useSectionDrawingPreviewQuery = ({
	fileId,
	fileName,
}: SectionDrawingPreviewParams) => {
	const hasFile = fileId !== null && Number.isInteger(fileId) && fileId > 0;
	const query = useQuery<Blob, Error>({
		queryKey: ["test-shack-section-image", fileId, fileName],
		queryFn: ({ signal }) =>
			downloadSectionSpecDrawing(fileId ?? 0, fileName, signal),
		enabled: hasFile,
		retry: false,
		refetchOnWindowFocus: false,
	});
	const objectUrl = useObjectUrl(query.data ?? null);
	const isPdf = isSectionSpecPdf(fileName, query.data?.type);
	const aspectRatio = usePdfAspectRatio(fileId, query.data ?? null, isPdf);

	return {
		...query,
		blob: query.data ?? null,
		hasFile,
		objectUrl,
		isPdf,
		aspectRatio,
	};
};
